import { useEffect } from 'react';
import { ViewerModeProvider } from './app/mode';
import { openPackFromInput } from './app/open-pack';
import { closePack } from './data/pack-store';
import { AppShell } from './ui/AppShell';
import './ui/styles/tokens.css';
import './ui/styles/base.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The complete Evidence Viewer page as an embeddable component — the same
 * UI whether it runs as the public standalone app or mounted on a route
 * inside a host app (kaneai's /evidence). Self-contained: brings its own
 * store (module-level, torn down on unmount), styles, and data layer.
 *
 * HOST REQUIREMENTS: render inside an LTThemeProvider (kaneai already has
 * one app-wide; the standalone shell provides its own), and give the
 * nearest ancestor a bounded height — the instance list scrolls within it.
 */
export function EvidenceViewer(_ref) {
  var initialPack = _ref.initialPack,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'view' : _ref$mode,
    reportExtras = _ref.reportExtras;
  useEffect(function () {
    if (initialPack) openPackFromInput(initialPack);
    // Leaving the page (route change in a host SPA) must release the open
    // pack: abort hydration, revoke object URLs, drop buffers.
    return function () {
      void closePack();
    };
  }, [initialPack]);
  return /*#__PURE__*/_jsx(ViewerModeProvider, {
    value: mode,
    children: /*#__PURE__*/_jsx(AppShell, {
      reportExtras: reportExtras
    })
  });
}